import { render } from "./Assetparameters.vue?vue&type=template&id=5ec85b43&scoped=true"
import script from "./Assetparameters.vue?vue&type=script&lang=js"
export * from "./Assetparameters.vue?vue&type=script&lang=js"

import "./Assetparameters.vue?vue&type=style&index=0&id=5ec85b43&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec85b43"]])

export default __exports__